import { createRootRoute, Outlet } from '@tanstack/react-router'
import { ReactNode } from "react";
import { Box } from "@mui/system";
import Header from "../components/Header";
import '@rainbow-me/rainbowkit/styles.css';
import { http } from "viem"
import {
  getDefaultConfig,
  RainbowKitProvider,
} from '@rainbow-me/rainbowkit';
import { WagmiProvider } from 'wagmi';
import {
  QueryClientProvider,
  QueryClient,
} from "@tanstack/react-query";
import { ManageVaultContextProvider } from '../context/ManageVaultContext';
import { ManageOracleRouterContextProvider } from '../context/ManageOracleRouterContext';
import { SnackbarProvider } from 'notistack';
import { arbitrum, base, mainnet, polygon, sonic, ink, swellchain, bob, unichain, berachain, bsc, avalanche, corn, optimism, gnosis, worldchain, morph, tac, linea, plasma, mantle } from 'viem/chains';
import { defineChain } from 'viem'
import { AddressBookContextProvider } from '../context/AddressBookContext';
import AddToAddressBookModal from '../components/AddToAddressBookModal';
import TosModal from '../components/TosModal';
import Footer from '../components/Footer';
import ScreeningProvider from '../components/ScreeningProvider';

const hyperevm = /*#__PURE__*/ defineChain({
  id: 999,
  name: 'HyperEVM',
  nativeCurrency: {
    name: 'HYPE',
    symbol: 'HYPE',
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: ['https://rpc.hyperliquid.xyz/evm'],
    },
  },
  blockExplorers: {
    default: {
      name: 'HyperEVMScan',
      url: 'https://hyperevmscan.io/',
    },
  },
})

const monad = /*#__PURE__*/ defineChain({
  id: 143,
  name: 'Monad',
  nativeCurrency: {
    name: 'Monad',
    symbol: 'MON',
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: ['https://white-ancient-sanctuary.monad-mainnet.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2/'],
    },
  },
  blockExplorers: {
    default: {
      name: 'MonVision',
      url: 'https://mainnet-beta.monvision.io/',
    },
  },
})

const config = getDefaultConfig({
  appName: 'EVK Vault Manager',
  projectId: '9e300f1a1f8184b813acdfc9d337a299',
  chains: [mainnet, base, swellchain, sonic, berachain, bob, avalanche, bsc, unichain, arbitrum, tac, linea, hyperevm, plasma, monad/*mantle, polygon, ink, , corn, optimism, gnosis, worldchain, morph*/],
  transports: {
    [mainnet.id]: http('https://white-ancient-sanctuary.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2'),
    [arbitrum.id]: http('https://white-ancient-sanctuary.arbitrum-mainnet.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2'),
    [polygon.id]: http('https://white-ancient-sanctuary.matic.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2'),
    [optimism.id]: http('https://white-ancient-sanctuary.optimism.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2'),
    [base.id]: http('https://white-ancient-sanctuary.base-mainnet.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2'),
    [gnosis.id]: http('https://white-ancient-sanctuary.xdai.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2'),
    [bsc.id]: http('https://white-ancient-sanctuary.bsc.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2'),
    [avalanche.id]: http('https://white-ancient-sanctuary.avalanche-mainnet.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2/ext/bc/C/rpc/'),
    [sonic.id]: http('https://white-ancient-sanctuary.sonic-mainnet.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2'),
    [swellchain.id]: http('https://rpc.ankr.com/swell/061768bae273f4863e9b0ed152f9ac16446b91c844cf1045580b325d9de2aa4a'),
    [ink.id]: http('https://white-ancient-sanctuary.ink-mainnet.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2'),
    [bob.id]: http('https://bob.gateway.tenderly.co/3lJlyWwFcXguIFSG5WaW69'),
    [unichain.id]: http('https://white-ancient-sanctuary.unichain-mainnet.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2'),
    [berachain.id]: http('https://white-ancient-sanctuary.bera-mainnet.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2'),
    [corn.id]: http('https://mainnet.corn-rpc.com'),
    [worldchain.id]: http('https://white-ancient-sanctuary.worldchain-mainnet.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2'),
    [morph.id]: http('https://white-ancient-sanctuary.morph-mainnet.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2'),
    [tac.id]: http('https://rpc.ankr.com/tac/061768bae273f4863e9b0ed152f9ac16446b91c844cf1045580b325d9de2aa4a'),
    [linea.id]: http('https://white-ancient-sanctuary.linea-mainnet.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2'),
    [hyperevm.id]: http('https://white-ancient-sanctuary.hype-mainnet.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2/evm'),
    [plasma.id]: http('https://white-ancient-sanctuary.plasma-mainnet.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2'),
    [mantle.id]: http('https://white-ancient-sanctuary.mantle-mainnet.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2'),
    [monad.id]: http('https://white-ancient-sanctuary.monad-mainnet.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2/')
  },
  ssr: true, // If your dApp uses server side rendering (SSR)
});

const queryClient = new QueryClient();

const Providers = (props: { children: ReactNode }) => {
  return (
    <SnackbarProvider>
      <WagmiProvider config={config}>
        <QueryClientProvider client={queryClient}>
          <RainbowKitProvider>
            <ScreeningProvider>
              <AddressBookContextProvider>
                <ManageVaultContextProvider>
                  <ManageOracleRouterContextProvider>
                    {props.children}
                  </ManageOracleRouterContextProvider>
                </ManageVaultContextProvider>
              </AddressBookContextProvider>
            </ScreeningProvider>
          </RainbowKitProvider>
        </QueryClientProvider>
      </WagmiProvider>
    </SnackbarProvider>
  );
};

export const Route = createRootRoute({
  component: () => (
    <Providers>
      {/* <Header /> */}
      {/* <Box> */}
      <Box className="contentAndFooterContainer" display={"flex"} flexDirection={"column"} flexGrow={1} minHeight={"100%"}>
        <Header />
        <Box flexGrow={1}>
          <Outlet />
        </Box>
        <Footer />
      </Box>
      {/* </Box> */}

      
      {/* <TanStackRouterDevtools /> */}
      <AddToAddressBookModal />
      <TosModal />
    </Providers>
  ),
})
